import PropTypes from "prop-types";
import React from "react";
import { Line } from "react-chartjs-2";
import NoChartData from "../Shared/NoChartData";

const LineChart = ({ data, title }) => {
  const isIncreasing = data.length > 1 && data[data.length - 1][1] >= data[data.length - 2][1];
  const chartData = {
    labels: data.map((item) => item[0]),
    datasets: [
      {
        data: data.map((item) => item[1]),
        fill: true,
        borderColor: isIncreasing ? "#22c55d" : "#ef4444",
        pointRadius: 0,
        tension: 0.1,
        datalabels: {
          labels: {
            title: null,
          },
        },
      },
    ],
  };

  if (!chartData || data.length <= 1) {
    return <NoChartData />;
  }

  return (
    <>
      {title && (
        <h3 className="dark:text-white font-semibold text-center text-gray-900 mb-2">
          {title}
        </h3>
      )}
      <Line width="400" data={chartData} />
    </>
  );
};

LineChart.propTypes = {
  data: PropTypes.array.isRequired,
  title: PropTypes.string,
};

export default LineChart;
